import { useState, useEffect, useCallback } from "react";

/** Simple history-based router. Returns current route and a navigate function. */
export function useRoute(): [string, (route: string) => void] {
  const getRoute = () => window.location.pathname;
  const [route, setRoute] = useState(getRoute);

  useEffect(() => {
    const handler = () => setRoute(getRoute());
    window.addEventListener("popstate", handler);
    return () => window.removeEventListener("popstate", handler);
  }, []);

  const navigate = useCallback((r: string) => {
    window.history.pushState({}, "", r);
    setRoute(new URL(r, window.location.origin).pathname);
  }, []);

  return [route, navigate];
}
